import { useState } from "react"
import { getSiteList } from "../services/alertGridServices";

export const useSite = () => {
    const [site, setSite] = useState([])
    const [siteOptions, setSiteOptions] = useState([]);

    const getSite = (id) => {
        getSiteList(id)
            .then((res) => {
                if (res.Status == "success") {
                    setSite(res.Data)
                    let arr = res.Data.filter(i => i.ParentID == null).map((item) => ({
                        value: item.SiteID,
                        label: item.SiteName
                    }))
                    setSiteOptions(arr);
                }else{
                    setSiteOptions([]);
                }
            })
            .catch(err => {
                setSiteOptions([])
            })
    }

    return { site, setSite, siteOptions, setSiteOptions, getSite }
}